import type { Variant } from '../types';

export interface StatCardProps {
  /** Big value, e.g. "38,289". */
  value: string;
  /** Caption under the value. */
  label: string;
  /** Phosphor icon class, e.g. "ph-trend-up". */
  icon: string;
  /** Icon tile color. Default primary. */
  color?: Variant;
  /** Optional trend indicator. */
  trend?: { direction: 'up' | 'down'; value: string };
  className?: string;
}

/** Limitless-style stat card: icon tile + value + label + optional trend. */
export function StatCard({ value, label, icon, color = 'primary', trend, className = '' }: StatCardProps) {
  return (
    <div className={`card card-body ${className}`.trim()}>
      <div className="d-flex align-items-center">
        <div
          className={`bg-${color} bg-opacity-10 text-${color} lh-1 rounded-pill p-2 me-3 d-inline-flex`}
        >
          <i className={`${icon} ph-lg`} />
        </div>
        <div className="flex-fill">
          <div className="d-flex align-items-center">
            <h4 className="mb-0">{value}</h4>
            {trend && (
              <span className={`ms-2 ${trend.direction === 'up' ? 'text-success' : 'text-danger'}`}>
                <i
                  className={`${trend.direction === 'up' ? 'ph-arrow-up' : 'ph-arrow-down'} fs-base lh-base align-top`}
                />
                {trend.value}
              </span>
            )}
          </div>
          <span className="text-muted">{label}</span>
        </div>
      </div>
    </div>
  );
}
